import React from 'react';

const progressBar = () => ({
  height: 10,
  background: '#e9ecef',
  borderRadius: 6,
  overflow: 'hidden',
  marginBottom: 8,
  position: 'relative'
});

const innerBar = (pct) => ({
  width: `${pct}%`,
  height: '100%',
  background: '#28a745',
  transition: 'width 300ms ease'
});

export default function BulkProgressPanel({ job, onPause, onResume, onCancel, onOpen }) {
  if (!job) return null;

  const pct = job.total > 0 ? Math.round((job.done * 100) / job.total) : 0;

  return (
    <div style={{ position: 'fixed', right: 18, bottom: 18, zIndex: 99999, width: 360, boxShadow: '0 6px 18px rgba(0,0,0,0.12)', borderRadius: 8, background: '#fff', padding: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <div style={{ fontWeight: 700 }}>Ajuste masivo — Progreso</div>
        <div style={{ fontSize: 12, color: '#666' }}>{job.status}</div>
      </div>
      <div style={progressBar(pct)}>
        <div style={innerBar(pct)} />
      </div>
      <div style={{ fontSize: 13, color: '#333', marginBottom: 8 }}>{job.done}/{job.total} procesados</div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        {job.status === 'running' ? (
          <button onClick={() => onPause && onPause(job.id)} style={{ padding: '6px 10px', background: '#ffc107', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Pausar</button>
        ) : (
          <button onClick={() => onResume && onResume(job.id)} style={{ padding: '6px 10px', background: '#17a2b8', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Reanudar</button>
        )}
        <button onClick={() => onCancel && onCancel(job.id)} style={{ padding: '6px 10px', background: '#dc3545', border: 'none', borderRadius: 6, color: '#fff', cursor: 'pointer' }}>Cancelar</button>
        <button onClick={() => onOpen && onOpen(job.id)} style={{ padding: '6px 10px', background: '#6c757d', border: 'none', borderRadius: 6, color: '#fff', cursor: 'pointer' }}>Ver</button>
      </div>
    </div>
  );
}
